module.exports = __webpack_public_path__ + "static/media/church.085ff625.jpg";